// @core/api/endpoints/userprofile/unban_userprofile.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  UnbanUserprofileRequest,
} from '../../../types/userprofile';

const BASE_PATH = '/userprofile';

/**
 * Unban user profile
 * Removes a ban from a user profile, restoring full access and visibility. The profile becomes active again immediately.
 */
export async function UnbanUserprofile(
  profile_id: string,
  data: UnbanUserprofileRequest,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/:profile_id/unban`;
  requestPath = requestPath.replace(':profile_id', encodeURIComponent(profile_id));
  const requestOptions = options;
  return client.post<Response>(requestPath, data, requestOptions);
}
